enum Installation
{
	Facade = 1,
	ExistingPillar = 2,
	Wood = 3,
	ConcreteWall = 4,
	NoMountingOptions = 5,
}

export default Installation;